import { Atom } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({ displayState }) => css`
    margin-left: 4px;
    text-decoration: ${displayState?.underline ? 'underline' : ''};
    margin-bottom: ${displayState?.underline ? '1px' : ''};
    display: ${displayState?.hidden ? 'none' : ''};
    max-width: 210px;
    white-space: nowrap;
    overflow: hidden;
  `}
`;

export default Atom({ type: 'label', dataType: 'string', template })